require('../../modules/es.typed-array.filter');
